import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {getClassNames} from './index.classNames';
import Scrollbars from 'react-custom-scrollbars-2';
import { Text } from '@fluentui/react/lib/Text';
import { DefaultButton, FontIcon, Spinner, SpinnerSize } from '@fluentui/react';
import { CommandActions as DocumentsCommandActions } from '../../redux/actions/documents';
import { getProjectDownloads } from '../../redux/reducers/documents';
import _ from 'lodash';

interface ProjectDownloadItem {
    jobId: string,
    projectId?: number,
    projectName?: string,
    downloadType?: 'project' | 'report',
    transmittalId?: string | null,
    status?: string,
    fileName?: string | null,
    totalBytes?: number | null,
    processedBytes?: number | null,
    totalRecords?: number | null,
    processedRecords?: number | null,
    createdUtc?: string | null,
}

export interface DownloadMenuProps { 
    projectDownloads: ProjectDownloadItem[],
    fetchProjectDownloads: typeof DocumentsCommandActions.fetchProjectDownloads,
    downloadProjectPackageFile: typeof DocumentsCommandActions.downloadProjectPackageFile,
    downloadExcelReportFile: typeof DocumentsCommandActions.downloadExcelReportFile
}

const styles = getClassNames();

class DownloadMenu extends React.Component<DownloadMenuProps> {
    constructor(props: DownloadMenuProps) {
        super(props);   
    }

    componentDidMount = () => {
        this.props.fetchProjectDownloads();
    };

    getDownloadPercentage = (download: ProjectDownloadItem): number => {
        const total = download.totalBytes || download.totalRecords;
        const processed = download.processedBytes || download.processedRecords;
        if(!total || total <= 0)
            return 0;
        const percentage = Math.round((((processed || 0) / total) * 100));
        return Math.max(0, Math.min(100, percentage));
    };

    getDownloadFileName = (download: ProjectDownloadItem): string => {
        if(download.downloadType === 'report')
            return download.fileName || 'Dashboard.xlsx';
        return download.transmittalId ? `${download.projectName || 'Project'}_Transmittal_${download.transmittalId}.zip` : `${download.projectName || 'Project'}_Project.zip`;
    };

    render(){
        const { projectDownloads, downloadProjectPackageFile, downloadExcelReportFile } = this.props;
        return (
            <Scrollbars style={{ height: '89vh' }}>
                <div className={styles.container}>
                    <div className={styles.formContainer}>
                        {projectDownloads.length === 0 &&
                            <Text variant={'medium'}>No downloads available.</Text>
                        }
                        {_.map(projectDownloads, download => {
                            const status = _.toLower(download.status || '');
                            const isQueued = status === 'queued';
                            const isRunning = status === 'running';
                            const isCompleted = status === 'completed';
                            const isFailed = status === 'failed';
                            const isExpired = status === 'expired';
                            const percentage = this.getDownloadPercentage(download);
                            const isReportDownload = download.downloadType === 'report';
                            return (
                                <div key={download.jobId} style={{border: '1px solid #edebe9', borderRadius: 4, padding: 12, marginRight: 15, marginBottom: 12}}>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        {isReportDownload && <FontIcon iconName={'ExcelDocument'} style={{color: '#008000', marginRight: 8}} />}
                                        <Text variant={'mediumPlus'}>{download.projectName || download.fileName || (download.projectId ? `Project ${download.projectId}` : 'Download')}</Text>
                                    </div>
                                    {!!download.transmittalId &&
                                        <div style={{marginTop: 4}}>
                                            <Text variant={'small'}>{`Transmittal ${download.transmittalId}`}</Text>
                                        </div>
                                    }
                                    <div style={{marginTop: 8}}>
                                        {isQueued && <Text style={{color: 'orange'}} variant={'small'}>Queued</Text>}
                                        {isRunning && <Text style={{color: 'grey'}} variant={'small'}>Running</Text>}
                                        {isCompleted && <Text style={{color: 'green'}} variant={'small'}>Completed</Text>}
                                        {isFailed && <Text style={{color: 'red'}} variant={'small'}>Failed</Text>}
                                        {isExpired && <Text style={{color: '#a4262c'}} variant={'small'}>Expired</Text>}
                                    </div>
                                    {(isRunning || isQueued) &&
                                        <div style={{display: 'flex', alignItems: 'center', marginTop: 8}}>
                                            <Spinner size={SpinnerSize.small} styles={{root: {marginRight: 8}}} />
                                            <Text variant={'small'}>{`${percentage}%`}</Text>
                                        </div>
                                    }
                                    {isCompleted &&
                                        <div style={{marginTop: 10}}>
                                            <DefaultButton
                                                text={'Download'}
                                                onClick={() => isReportDownload ? downloadExcelReportFile({jobId: download.jobId, fileName: this.getDownloadFileName(download)}) : downloadProjectPackageFile({jobId: download.jobId, fileName: this.getDownloadFileName(download)})}
                                            />
                                        </div>
                                    }
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Scrollbars>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    projectDownloads: getProjectDownloads
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        fetchProjectDownloads: DocumentsCommandActions.fetchProjectDownloads,
        downloadProjectPackageFile: DocumentsCommandActions.downloadProjectPackageFile,
        downloadExcelReportFile: DocumentsCommandActions.downloadExcelReportFile
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(DownloadMenu);